import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/v1/dealer-discounts', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/v1/dealer-discounts', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = data => {
  return httpClient
    .post('/api/v1/dealer-discounts/destroy', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getDealerType = (Options = {}) => {
  return httpClient
    .get('/api/v1/dealer-discounts/dealer-types', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getProduct = () => {
  return httpClient
    .get('/api/v1/dealer-discounts/products/')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  store,
  getDealerType,
  getProduct,
  destroy
}
